// Soft singing-bowl chime synthesized with the Web Audio API (432Hz harmonic).
let audioCtx = null;

export function playChime() {
  try {
    if (typeof window === "undefined") return;
    if (localStorage.getItem("reiki-muted") === "true") return;
    const AudioContext = window.AudioContext || window.webkitAudioContext;
    if (!AudioContext) return;
    if (!audioCtx) audioCtx = new AudioContext();
    if (audioCtx.state === "suspended") audioCtx.resume();

    const now = audioCtx.currentTime;
    const master = audioCtx.createGain();
    master.gain.setValueAtTime(0.0001, now);
    master.gain.exponentialRampToValueAtTime(0.22, now + 0.05);
    master.gain.exponentialRampToValueAtTime(0.0001, now + 4.5);
    master.connect(audioCtx.destination);

    const partials = [432, 864, 1296, 1728];
    partials.forEach((freq, i) => {
      const osc = audioCtx.createOscillator();
      const g = audioCtx.createGain();
      osc.type = "sine";
      osc.frequency.value = freq;
      g.gain.value = 1 / (i + 1.4);
      osc.connect(g);
      g.connect(master);
      osc.start(now);
      osc.stop(now + 4.5);
    });
  } catch (e) {
    /* silence is golden */
  }
}

export function isMuted() {
  if (typeof window === "undefined") return false;
  return localStorage.getItem("reiki-muted") === "true";
}

export function toggleMute() {
  const next = !isMuted();
  localStorage.setItem("reiki-muted", String(next));
  return next;
}
